import { useState, useEffect, useRef } from 'react'
import { useAuth } from '../context/AuthContext'
import { NAV_GROUPS } from '../lib/navigationConfig'

const C = {
  ink:'#0F1017', ink2:'#374151', sub:'#6B7280', muted:'#9CA3AF',
  paper:'#F3F4F6', surface:'#fff', border:'#E5E7EB', border2:'#D1D5DB',
  green:'#1A7A4A', gbg:'rgba(26,122,74,.07)', gline:'rgba(26,122,74,.25)',
}


// SVG icons per module
const ICON = ({ page }) => {
  const s = { width:14, height:14, stroke:'currentColor', fill:'none', strokeWidth:'1.4', strokeLinecap:'round', strokeLinejoin:'round' }
  const icons = {
    dashboard:          <><rect x="1" y="1" width="6" height="6" rx="1"/><rect x="9" y="1" width="6" height="6" rx="1"/><rect x="1" y="9" width="6" height="6" rx="1"/><rect x="9" y="9" width="6" height="6" rx="1"/></>,
    projects:           <><path d="M2 4h3l1.5-2h6L14 4v9a1 1 0 01-1 1H3a1 1 0 01-1-1V4z"/><line x1="5" y1="8" x2="11" y2="8"/></>,
    organizations:      <><rect x="5" y="1" width="6" height="4" rx="0.5"/><rect x="1" y="11" width="5" height="4" rx="0.5"/><rect x="10" y="11" width="5" height="4" rx="0.5"/><line x1="8" y1="5" x2="8" y2="8.5"/><line x1="3.5" y1="8.5" x2="12.5" y2="8.5"/><line x1="3.5" y1="8.5" x2="3.5" y2="11"/><line x1="12.5" y1="8.5" x2="12.5" y2="11"/></>,
    'cost-codes':       <><polyline points="4,5 2,8 4,11"/><polyline points="12,5 14,8 12,11"/><line x1="7" y1="3" x2="9" y2="13"/></>,
    users:              <><circle cx="6" cy="5" r="2.5"/><path d="M1 14c0-2.76 2.24-5 5-5s5 2.24 5 5"/><path d="M12 7c1.1 0 2 .9 2 2s-.9 2-2 2"/><path d="M14 14c0-1.66-1.34-3-3-3"/></>,
    boq:                <><rect x="2" y="2" width="12" height="12" rx="1"/><line x1="2" y1="6" x2="14" y2="6"/><line x1="2" y1="10" x2="14" y2="10"/><line x1="6" y1="6" x2="6" y2="14"/></>,
    'change-register':  <><path d="M3 8h10M9 4l4 4-4 4"/></>,
    'eot-register':     <><circle cx="8" cy="8" r="6.5"/><line x1="8" y1="4" x2="8" y2="8"/><line x1="8" y1="8" x2="11" y2="8"/></>,
    'risk-register':    <><path d="M8 1.5L14.5 13H1.5Z"/><line x1="8" y1="6" x2="8" y2="9.5"/><circle cx="8" cy="11.5" r=".6" fill="currentColor" stroke="none"/></>,
    'rate-analysis':    <><polyline points="1.5,11 5,6.5 8,9 11,4.5 14.5,2.5"/><circle cx="5" cy="6.5" r="1" fill="currentColor" stroke="none"/><circle cx="8" cy="9" r="1" fill="currentColor" stroke="none"/><circle cx="11" cy="4.5" r="1" fill="currentColor" stroke="none"/></>,
    budget:             <><rect x="1.5" y="3" width="13" height="10" rx="1"/><line x1="8" y1="5.5" x2="8" y2="10.5"/><line x1="5.5" y1="8" x2="10.5" y2="8"/></>,
    indirect:           <><rect x="1.5" y="3" width="13" height="10" rx="1"/><path d="M5 8.5Q8 5.5 11 8.5"/></>,
    'budget-summary':   <><rect x="2" y="2" width="12" height="12" rx="1"/><polyline points="4.5,9.5 6.5,7 9,9 13,5"/></>,
    'final-account':    <><rect x="2" y="1.5" width="12" height="13" rx="1"/><line x1="5" y1="5.5" x2="11" y2="5.5"/><line x1="5" y1="8" x2="11" y2="8"/><line x1="5" y1="10.5" x2="8.5" y2="10.5"/></>,
    'purchase-requisitions': <><rect x="3" y="1.5" width="10" height="13" rx="1"/><line x1="6" y1="5" x2="10" y2="5"/><line x1="6" y1="8" x2="10" y2="8"/><line x1="6" y1="11" x2="8" y2="11"/></>,
    rfq:                <><path d="M2 2h12l-1.5 8H3.5z"/><path d="M9.5 2l1 8"/><path d="M6.5 2l-1 8"/></>,
    'purchase-orders':  <><path d="M2 2h1.5l1.8 7h7l1.7-5H5.3"/><circle cx="7" cy="13.5" r="1"/><circle cx="11" cy="13.5" r="1"/></>,
    store:              <><rect x="3" y="7" width="10" height="7" rx="0.5"/><path d="M1 7l2-4h10l2 4"/><line x1="8" y1="7" x2="8" y2="14"/></>,
    'po-reconciliation':<><rect x="2" y="2" width="5.5" height="7" rx="0.5"/><rect x="8.5" y="7" width="5.5" height="7" rx="0.5"/><line x1="4.75" y1="9" x2="4.75" y2="14"/><line x1="11.25" y1="2" x2="11.25" y2="7"/></>,
    'vendor-master':    <><circle cx="8" cy="5" r="2.5"/><path d="M3 14c0-2.76 2.24-5 5-5s5 2.24 5 5"/><line x1="12" y1="9" x2="14" y2="9"/><line x1="13" y1="8" x2="13" y2="10"/></>,
    subcontracts:       <><path d="M4 13V8a2 2 0 012-2h6"/><polyline points="9,4 12,6 9,8"/><path d="M12 3v10"/></>,
    ipc:                <><rect x="3" y="1.5" width="10" height="13" rx="1"/><polyline points="6,7 7.5,9 10.5,5.5"/><line x1="5" y1="11.5" x2="11" y2="11.5"/></>,
    retention:          <><rect x="3" y="8" width="10" height="6" rx="1"/><path d="M5 8V6a3 3 0 016 0v2"/><circle cx="8" cy="11" r="1" fill="currentColor" stroke="none"/></>,
    payroll:            <><circle cx="8" cy="5.5" r="2.5"/><path d="M3 14c0-2.76 2.24-5 5-5s5 2.24 5 5"/></>,
    finance:            <><circle cx="8" cy="8" r="6.5"/><line x1="8" y1="4" x2="8" y2="5.5"/><line x1="8" y1="10.5" x2="8" y2="12"/><path d="M6 7c0-1 .9-1.5 2-1.5s2 .5 2 1.5-1 1.5-2 1.5-2 .5-2 1.5.9 1.5 2 1.5 2-.5 2-1.5"/></>,
    accrual:            <><polyline points="1.5,12 5,7 8,9.5 11,5 14.5,8"/></>,
    'petty-cash':       <><rect x="1.5" y="5" width="13" height="8" rx="1"/><path d="M5 5V4a3 3 0 016 0v1"/><circle cx="8" cy="9" r="1.5"/></>,
    'cost-assessment':  <><circle cx="7" cy="7" r="5"/><line x1="10.5" y1="10.5" x2="14" y2="14"/><line x1="5" y1="7" x2="9" y2="7"/><line x1="7" y1="5" x2="7" y2="9"/></>,
    'direct-forecast':  <><polyline points="1.5,12 5,7 8,9.5 11,5 14.5,8"/><polyline points="11,5 14.5,5 14.5,8"/></>,
    'indirect-forecast':<><polyline points="1.5,12 5,7 8,9.5 11,5 14.5,8"/><line x1="3" y1="14.5" x2="13" y2="14.5"/></>,
    'release-management': <><rect x="3.5" y="7" width="9" height="7" rx="1"/><path d="M5.5 7V4.5a2.5 2.5 0 015 0V7"/></>,
    costcontrol:        <><rect x="1.5" y="1.5" width="4.5" height="13" rx=".5"/><rect x="5.75" y="5" width="4.5" height="9.5" rx=".5"/><rect x="10" y="8.5" width="4.5" height="6" rx=".5"/></>,
    'monthly-cost':     <><rect x="1.5" y="3" width="13" height="10" rx="1"/><line x1="1.5" y1="7" x2="14.5" y2="7"/><line x1="5" y1="3" x2="5" y2="13"/><line x1="9" y1="3" x2="9" y2="13"/></>,
    'analytics-studio': <><rect x="1.5" y="8" width="3" height="5.5" rx=".4"/><rect x="6" y="5" width="3" height="8.5" rx=".4"/><rect x="10.5" y="2" width="3" height="11.5" rx=".4"/><polyline points="2.5,6 6,4 10,5.5 13.5,1.5" strokeWidth="1.2"/></>,
    curves:             <><polyline points="1,13 4,8 7,10 10,5 15,7"/></>,
    productivity:       <><rect x="2" y="2" width="5" height="5" rx=".5"/><rect x="9" y="2" width="5" height="5" rx=".5"/><rect x="2" y="9" width="5" height="5" rx=".5"/><line x1="9" y1="11.5" x2="14" y2="11.5"/><line x1="11.5" y1="9" x2="11.5" y2="14"/></>,
    alerts:             <><path d="M8 1.5L14.5 13H1.5Z"/><line x1="8" y1="6" x2="8" y2="9.5"/><circle cx="8" cy="11.5" r=".6" fill="currentColor" stroke="none"/></>,
    documents:          <><path d="M4 2h6l3 3v9a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1z"/><polyline points="10,2 10,5 13,5"/><line x1="5" y1="8" x2="11" y2="8"/><line x1="5" y1="11" x2="9" y2="11"/></>,
    'document-governance': <><path d="M4 2h6l3 3v9a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1z"/><polyline points="10,2 10,5 13,5"/><path d="M5.5 8.5L7 10l3-3" strokeWidth="1.3"/></>,
    'equipment-productivity': <><path d="M2 12l2-5h3l1-2h3l2 4h1.5"/><circle cx="5" cy="12.5" r="1.5"/><circle cx="11" cy="12.5" r="1.5"/></>,
    'site-allocation':  <><rect x="2" y="2" width="12" height="12" rx="1"/><path d="M5 6h6M5 9h4"/><path d="M9.5 10.5L11 12l2.5-2.5" strokeWidth="1.3"/></>,
    'qs-tracking':      <><polyline points="4,5 2,8 4,11"/><polyline points="12,5 14,8 12,11"/><line x1="7" y1="3" x2="9" y2="13"/><line x1="1.5" y1="8" x2="14.5" y2="8" strokeDasharray="1.5 1.5"/></>,
    'risks-changes':    <><path d="M3 8h10M9 4l4 4-4 4"/><circle cx="8" cy="8" r="6.5" strokeDasharray="1.5 1"/></>,
    workspace:          <><rect x="1" y="1" width="6" height="9" rx="1"/><rect x="9" y="1" width="6" height="4" rx="1"/><rect x="9" y="7" width="6" height="8" rx="1"/><rect x="1" y="12" width="6" height="3" rx="1"/></>,
    'inventory-management': <><path d="M2 5.5l6-3.5 6 3.5v5L8 14l-6-3.5z"/><path d="M2 5.5L8 9l6-3.5"/><line x1="8" y1="9" x2="8" y2="14"/></>,
    'material-master':  <><rect x="3" y="7" width="10" height="7" rx="0.5"/><path d="M1 7l2-4h10l2 4"/><line x1="8" y1="7" x2="8" y2="14"/><circle cx="8" cy="10.5" r="1.2" fill="currentColor" stroke="none"/></>,
    permissions:        <><rect x="2" y="2" width="12" height="12" rx="2"/><line x1="5" y1="6" x2="11" y2="6"/><line x1="5" y1="9" x2="9" y2="9"/></>,
    'pending-approvals': <><circle cx="8" cy="8" r="6.5"/><polyline points="8,4.5 8,8.5 10.5,10"/></>,
  }
  return <svg viewBox="0 0 16 16" style={s}>{icons[page] || null}</svg>
}

export default function HomeLaunchpad({ onNavigate }) {
  const { user, profile, signOut } = useAuth()
  const [activeGrp, setActiveGrp] = useState('all')
  const now = new Date().toLocaleDateString('en-GB', { weekday:'short', day:'numeric', month:'short', year:'numeric' })
  const [search, setSearch] = useState('')
  const searchRef = useRef(null)
  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const name = profile?.full_name || user?.email || 'User'
  const initials = name.includes('@') ? name[0].toUpperCase() : name.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase()

  // Filter
  const q = search.toLowerCase().trim()
  const visibleGroups = NAV_GROUPS.map(grp => {
    if (activeGrp !== 'all' && activeGrp !== grp.id) return null
    const items = q ? grp.items.filter(i => i.label.toLowerCase().includes(q) || i.sub.toLowerCase().includes(q)) : grp.items
    if (!items.length) return null
    return { ...grp, items }
  }).filter(Boolean)

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%', fontFamily:'inherit', background:C.surface, overflow:'hidden' }}>

      {/* ── Top bar ── */}
      <div style={{ background:C.surface, borderBottom:`1px solid ${C.border}`, padding:'11px 28px', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0, gap:16 }}>
        <div style={{ display:'flex', alignItems:'center' }}>
          <div style={{ fontSize:12, fontWeight:700, color:C.ink }}>CostSpace Enterprise Cost Intelligence</div>
          <span style={{ color:C.border2, margin:'0 8px' }}>·</span>
          <div style={{ fontSize:12, color:C.sub }}>All Modules</div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <span style={{ fontSize:11.5, color:C.muted }}>{now}</span>
          {/* Inline search */}
          <div style={{ display:'flex', alignItems:'center', gap:6, padding:'5px 12px', background:C.paper, border:`1px solid ${C.border2}`, borderRadius:4, transition:'border-color .1s' }}
            onFocus={e=>e.currentTarget.style.borderColor=C.green}
            onBlur={e=>e.currentTarget.style.borderColor=C.border2}>
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke={C.sub} strokeWidth="1.4"><circle cx="6.5" cy="6.5" r="4.5"/><line x1="9.5" y1="9.5" x2="14" y2="14"/></svg>
            <input ref={searchRef} value={search} onChange={e => { setSearch(e.target.value); setActiveGrp('all') }}
              placeholder="Search modules…"
              style={{ border:'none', background:'none', outline:'none', fontSize:12, color:C.ink, width:160, fontFamily:'inherit' }}/>
            {search && <button onClick={()=>setSearch('')} style={{ border:'none', background:'none', cursor:'pointer', color:C.muted, fontSize:12, padding:0, lineHeight:1 }}>✕</button>}
          </div>
          {/* User avatar + sign out */}
          <div style={{ position:'relative' }}>
            <div onClick={() => setUserMenuOpen(v=>!v)}
              style={{ display:'flex', alignItems:'center', gap:7, cursor:'pointer', padding:'4px 8px', borderRadius:6, border:`1px solid ${C.border}`, background:C.paper, transition:'border-color .1s' }}
              onMouseEnter={e=>e.currentTarget.style.borderColor=C.green}
              onMouseLeave={e=>e.currentTarget.style.borderColor=C.border}>
              <div style={{ width:24, height:24, borderRadius:'50%', background:'linear-gradient(135deg,#1A7A4A,#2FA866)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, fontWeight:700, color:'#fff', flexShrink:0 }}>
                {initials}
              </div>
              <div style={{ fontSize:11, fontWeight:600, color:C.ink2, maxWidth:100, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{name}</div>
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke={C.sub} strokeWidth="1.5"><polyline points="2,4 5,7 8,4"/></svg>
            </div>
            {userMenuOpen && (
              <>
                <div onClick={() => setUserMenuOpen(false)} style={{ position:'fixed', inset:0, zIndex:49 }}/>
                <div style={{ position:'absolute', top:'calc(100% + 4px)', right:0, zIndex:50, background:'#fff', border:`1px solid ${C.border}`, borderRadius:8, padding:'6px 0', boxShadow:'0 4px 16px rgba(0,0,0,.12)', minWidth:160 }}>
                  <div style={{ padding:'6px 14px 8px', borderBottom:`1px solid ${C.border}` }}>
                    <div style={{ fontSize:11, fontWeight:600, color:C.ink }}>{name}</div>
                    <div style={{ fontSize:10, color:C.muted, marginTop:1 }}>{profile?.role || 'User'}</div>
                  </div>
                  <button onClick={() => { setUserMenuOpen(false); if(window.confirm('Sign out?')) signOut() }}
                    style={{ width:'100%', textAlign:'left', padding:'8px 14px', fontSize:12, color:'#DC2626', background:'none', border:'none', cursor:'pointer', display:'flex', alignItems:'center', gap:7 }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                    Sign Out
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ── Two-panel shell ── */}
      <div style={{ display:'flex', flex:1, overflow:'hidden' }}>

        {/* ── Left: Category list ── */}
        <div style={{ width:196, flexShrink:0, borderRight:`1px solid ${C.border}`, background:'#F8F9FB', overflowY:'auto', padding:'8px 0' }}>
          {[{ id:'all', label:'All Modules' }, ...NAV_GROUPS.map(g => ({ id:g.id, label:g.label }))].map(cat => (
            <button key={cat.id} onClick={() => { setActiveGrp(cat.id); setSearch('') }}
              style={{
                display:'flex', alignItems:'center', width:'100%', padding:'8px 16px',
                background:'none', border:'none', borderLeft:`2px solid ${activeGrp===cat.id ? C.green : 'transparent'}`,
                textAlign:'left', fontSize:12, fontWeight: activeGrp===cat.id ? 600 : 500,
                color: activeGrp===cat.id ? C.green : C.sub,
                cursor:'pointer', transition:'all .1s', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis',
                background: activeGrp===cat.id ? C.gbg : 'transparent',
              }}
              onMouseEnter={e => { if(activeGrp!==cat.id) { e.currentTarget.style.background='#ECEEF2'; e.currentTarget.style.color=C.ink } }}
              onMouseLeave={e => { if(activeGrp!==cat.id) { e.currentTarget.style.background='transparent'; e.currentTarget.style.color=C.sub } }}>
              {cat.label}
            </button>
          ))}
        </div>

        {/* ── Right: Module items ── */}
        <div style={{ flex:1, overflowY:'auto', background:C.surface }}>
          {visibleGroups.length === 0 ? (
            <div style={{ padding:'48px 28px', textAlign:'center', color:C.muted }}>
              <p style={{ fontSize:14, fontWeight:600, color:C.sub }}>No modules match "{search}"</p>
            </div>
          ) : visibleGroups.map(grp => (
            <div key={grp.id}>
              {/* Section header */}
              <div style={{
                padding:'8px 28px', fontSize:9, fontWeight:700, textTransform:'uppercase',
                letterSpacing:'.14em', color:C.muted, background:'#F8F9FB',
                borderTop:`1px solid ${C.border}`, borderBottom:`1px solid ${C.border}`,
                position:'sticky', top:0, zIndex:1,
              }}>
                {grp.label}
              </div>

              {/* Items */}
              {grp.items.map(item => (
                <ModuleItem key={item.page} item={item} onNavigate={onNavigate}/>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function ModuleItem({ item, onNavigate }) {
  const [hov, setHov] = useState(false)
  const hasTabs = item.insideTabs && item.insideTabs.length > 0
  return (
    <div
      onClick={() => onNavigate(item.page)}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        display:'flex', alignItems:'flex-start', gap:14, padding:'10px 28px',
        borderBottom:`1px solid ${C.border}`, cursor:'pointer',
        background: hov ? '#EEF5FF' : C.surface, transition:'background .1s',
      }}>
      {/* Icon */}
      <div style={{
        width:28, height:28, borderRadius:4, background:C.paper,
        border:`1px solid ${hov ? C.green : C.border}`,
        display:'flex', alignItems:'center', justifyContent:'center',
        flexShrink:0, transition:'border-color .1s', marginTop:1,
        color: hov ? C.green : C.ink2,
      }}>
        <ICON page={item.page}/>
      </div>

      {/* Text */}
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:6 }}>
          <span style={{ fontSize:12.5, fontWeight:500, color:C.ink }}>{item.label}</span>
          {item.badge && (
            <span style={{ fontSize:9, fontWeight:600, padding:'1px 6px', borderRadius:8, background:C.gbg, color:C.green }}>
              {item.badge}
            </span>
          )}
        </div>
        <div style={{ fontSize:11, color:C.sub, marginTop:1 }}>{item.sub}</div>

        {/* Inside-tabs preview — only for confirmed-complex modules, keeps
            simple modules (88% of the total) visually unchanged. */}
        {hasTabs && (
          <div style={{ display:'flex', flexWrap:'wrap', gap:5, marginTop:6 }}>
            {item.insideTabs.slice(0, 4).map((tab, i) => (
              <span key={i} style={{
                fontSize:9.5, padding:'2px 7px', borderRadius:4,
                background:C.paper, color:C.sub, border:`1px solid ${C.border}`,
              }}>
                {tab.label}
              </span>
            ))}
            {item.insideTabs.length > 4 && (
              <span style={{ fontSize:9.5, padding:'2px 7px', borderRadius:4, background:C.paper, color:C.sub, border:`1px solid ${C.border}` }}>
                +{item.insideTabs.length - 4} more
              </span>
            )}
          </div>
        )}
      </div>

      {/* Arrow */}
      <span style={{ color: hov ? C.green : C.border2, fontSize:16, lineHeight:1, flexShrink:0, marginTop:4, transition:'color .1s' }}>›</span>
    </div>
  )
}
